import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const duplicateScenario = api(async function duplicateScenario({ id }) {
    return mutate(
        gql`
            mutation DuplicateScenario($id: String!) {
                duplicateScenario(id: $id) {
                    id
                    name
                    regimeId
                    rateCardId
                    status
                }
            }
        `,
        { id },
        { returns: "duplicateScenario" }
    )
})
